import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import IconWithNotification from '../IconWithNotification';
import s from './SiteHeaderIconButton.scss';
var SiteHeaderIconButton = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName, isActive = _a.isActive, biData = _a.biData, onClick = _a.onClick, icon = _a.icon, count = _a.count, ariaLabel = _a.ariaLabel, href = _a.href;
    return (React.createElement(PlainButtonOrLink, { href: href, biData: biData, className: classnames(s['icon-button'], isActive && s['active'], className), onClick: onClick, "aria-label": ariaLabel },
        React.createElement(IconWithNotification, { icon: icon, iconClassName: classnames(s['icon'], iconClassName), numberClassName: numberClassName, count: count })));
};
SiteHeaderIconButton.displayName = 'SiteHeaderIconButton';
export default SiteHeaderIconButton;
//# sourceMappingURL=SiteHeaderIconButton.js.map